import { render, staticRenderFns } from "./SurveyRadio.vue?vue&type=template&id=9a610f98&"
import script from "./SurveyRadio.vue?vue&type=script&lang=js&"
export * from "./SurveyRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports